export function header() {
  let trigger = document.getElementById('js-navTrigger');
  const header = document.querySelector('.l-header');

  if (trigger) {
    trigger.addEventListener('click', function () {
      let target = document.getElementById('js-navTarget');
      trigger.classList.toggle('is-show');
      target.classList.toggle('is-show');
    }, false);
  }

  // スクロール量1以上でclass付与
  document.addEventListener('scroll', () => {
    if (window.scrollY > 0) {
      header.classList.add('is-active');
    } else {
      header.classList.remove('is-active');
    }
  });
}
